export default "/images/065211030230bf847e7eb7211f72a2f9.avif";